const GENERIC_CTA_CLICKED_EVENT = {
  TYPES: {
    BUTTON: 'button',
    PILL_TOGGLE: 'pill toggle',
    LINK: 'link',
    ICON: 'icon',
    SEARCH: 'search',
    CARD: 'card',
  },
  LOCATIONS: {
    PDP: 'pdp',
    STORE_LOCATION_CARD: 'store locator card',
    STORY_CARD: 'story card',
    STORY_CARD_V2: 'story card v2',
    CART: 'cart',
    CHECKOUT: 'checkout',
    NOT_FOUND: '404',
    NOT_FOUND_CATEGORY_ENTRY: '404 category entry',
    PARTNERSHIP_PAGE: 'partnership page',
  },
  CAMPAIGNS: {
    COLLECTIONS_CLICKABLE_STORY_CARD: 'Parent Collection - Clickable Story Cards',
  },
};

export default GENERIC_CTA_CLICKED_EVENT;
